import React from "react";
import { Box, Avatar, IconButton } from "@mui/material";
import { alpha } from "@mui/material/styles";
import EditIcon from "@mui/icons-material/Edit";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";

export default function AvatarPicker({ src, onEdit, onRemove }) {
  return (
    <Box
      sx={(theme) => ({
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        p: 1,
        borderRadius: "50%",
        background:
          theme.palette.mode === "dark"
            ? `radial-gradient(circle, ${alpha(theme.colors.blue, 0.22)} 0%, transparent 70%)`
            : `radial-gradient(circle, ${alpha(theme.colors.blue, 0.12)} 0%, transparent 72%)`,
      })}
    >
      <Avatar
        src={src}
        alt="Profile Image"
        sx={(theme) => ({
          width: 132,
          height: 132,
          border: `3px solid ${alpha(theme.colors.blue, 0.9)}`,
          boxShadow:
            theme.palette.mode === "dark"
              ? "0 12px 28px rgba(0, 0, 0, 0.36)"
              : "0 12px 24px rgba(17, 82, 228, 0.14)",
        })}
      />
      <IconButton
        onClick={onEdit}
        sx={(theme) => ({
          position: "absolute",
          bottom: 8,
          right: 8,
          backgroundColor: theme.palette.background.paper,
          border: `2px solid ${alpha(theme.colors.blue, 0.9)}`,
          boxShadow:
            theme.palette.mode === "dark"
              ? "0 8px 18px rgba(0, 0, 0, 0.35)"
              : "0 8px 16px rgba(17, 82, 228, 0.18)",
          "&:hover": { backgroundColor: theme.palette.action.hover },
        })}
        size="small"
      >
        <EditIcon fontSize="small" />
      </IconButton>
      <IconButton
        onClick={onRemove}
        sx={(theme) => ({
          position: "absolute",
          top: 8,
          right: 8,
          backgroundColor: theme.palette.background.paper,
          border: `2px solid ${alpha(theme.palette.error.main, 0.55)}`,
          color: theme.palette.error.main,
          boxShadow:
            theme.palette.mode === "dark"
              ? "0 8px 18px rgba(0, 0, 0, 0.35)"
              : "0 8px 16px rgba(17, 82, 228, 0.18)",
          "&:hover": { backgroundColor: theme.palette.action.hover },
        })}
        size="small"
      >
        <ClearOutlinedIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
